import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './components/contexts/AuthContext'; // Updated import
import { GlobalContext } from './components/contexts/GlobalContext';
import { useState, useEffect, Suspense } from 'react';

import { SocketProvider } from './components/contexts/SocketContext'; // Updated path
import { CSpinner } from '@coreui/react';
import DrawerNew from './components/DrawerNew';
import GetTitle from './components/GetTitle';

// Import Pages
import Landing from './components/Home/Landing';
import Login from './pages/Login';
import DashboardV2 from './pages/DashboardV2';
import Users from './pages/Users';
import QuerysetV2 from './pages/Querysetv2';
import WhatsappMessages from './pages/WhatsappMessages';
import Supplier from './pages/Supplier';
import Hrm from './pages/HRM';
import Reports from './pages/Reports';
import OverviewReport from './pages/Reports/Overview';
import NotFound from './components/Modals/NotFound';

// Create a wrapper component for authenticated routes
const AuthenticatedApp = () => {
  const { authState } = useAuth();

  const canAccessGeneralPages = Boolean(authState.username?.toLowerCase().includes('autoteileusedparts'));
  const canAccessHrm = [1, 33].includes(Number(authState.id));
  const isGmailUser = Boolean(authState.username?.toLowerCase().endsWith('@gmail.com'));
  const canAccessQueryset = canAccessGeneralPages || isGmailUser;
  const gated = (element, allowed) => (allowed ? element : <NotFound />);

  return (
    <Routes>
      {!authState.isAuthenticated ? (
        <>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="*" element={<Navigate to="/login" />} />
        </>
      ) : (
        <Route path="/" element={<DrawerNew title={<GetTitle />} />}>
          <Route path="/login" element={<Navigate to="/querysetv2" />} />
          <Route index element={gated(<DashboardV2 />, canAccessGeneralPages)} />
          <Route path="/dashboard" element={gated(<DashboardV2 />, canAccessGeneralPages)} />
          <Route path="/users" element={gated(<Users />, canAccessGeneralPages)} />
          <Route path="/queryset" element={gated(<QuerysetV2 />, canAccessQueryset)} />
          <Route path="/querysetv2" element={gated(<QuerysetV2 />, canAccessQueryset)} />
          <Route path="/whatsapp_messages" element={gated(<WhatsappMessages />, canAccessGeneralPages)} />
          <Route path="/suppliers" element={gated(<Supplier />, canAccessGeneralPages)} />
          <Route path="/hrm" element={gated(<Hrm />, canAccessHrm)} />
          <Route path="/reports" element={gated(<Reports />, canAccessGeneralPages)} />
          <Route path="/reports/overview" element={gated(<OverviewReport />, canAccessGeneralPages)} />
          <Route path="*" element={<NotFound />} />
        </Route>
      )}
    </Routes>
  );
};

function App() {
  const [globalState, setGlobalState] = useState({
    messages: [],
    queryset: [],
    approval_messages: [],
  });

  return (
    <GlobalContext.Provider value={{ globalState, setGlobalState }}>
      <AuthProvider>
        <SocketProvider>
          <Router>
            <Suspense fallback={<CSpinner color="primary" />}>
              <AuthenticatedApp />
            </Suspense>
          </Router>
        </SocketProvider>
      </AuthProvider>
    </GlobalContext.Provider>
  );
}

export default App;
